module.exports = __webpack_public_path__ + "img/next-arrow.9ac89782.svg";